(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/hooks/assets/javascripts/use-get-participants.js') >= 0) return;  svs.modules.push('/components/tipsen/hooks/assets/javascripts/use-get-participants.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const createBetEventKey = svs.components.sportinfo.common.helpers.createBetEventKey;
const _svs$components$sport = svs.components.sportinfo.matchInfoRedux.selectors,
  selectBetEvent = _svs$components$sport.selectBetEvent,
  selectBetEventsByDraw = _svs$components$sport.selectBetEventsByDraw,
  selectParticipant = _svs$components$sport.selectParticipant,
  selectAllParticipants = _svs$components$sport.selectAllParticipants;
const useGetParticipantsByDraw = (productId, drawNumber) => {
  const betEvents = useSelector(state => selectBetEventsByDraw(state, productId, drawNumber));
  const allParticipants = useSelector(state => selectAllParticipants(state));
  if (!betEvents) {
    return [];
  }
  const betEventsArray = Object.entries(betEvents).map(_ref => {
    let _ref2 = _slicedToArray(_ref, 2),
      betEventId = _ref2[0],
      betEvent = _ref2[1];
    return {
      betEventId,
      participants: betEvent.participants
    };
  });
  betEventsArray.sort((current, next) => current.betEventId - next.betEventId);
  const participantsByBetEvent = betEventsArray.map(betEvent => {
    var _betEvent$participant;
    const _ref3 = (_betEvent$participant = betEvent === null || betEvent === void 0 ? void 0 : betEvent.participants) !== null && _betEvent$participant !== void 0 ? _betEvent$participant : [],
      _ref4 = _slicedToArray(_ref3, 2),
      homeParticipantId = _ref4[0],
      awayParticipantId = _ref4[1];
    const homeParticipant = allParticipants[homeParticipantId];
    const awayParticipant = allParticipants[awayParticipantId];
    return [homeParticipant, awayParticipant];
  });
  return participantsByBetEvent;
};
const useGetParticipantsByEvent = (productId, drawNumber, betEventNumber) => {
  const betEvent = useSelector(state => selectBetEvent(state, createBetEventKey(productId, drawNumber, betEventNumber)));
  const homeParticipant = useSelector(state => selectParticipant(state, betEvent !== null && betEvent !== void 0 && betEvent.participants[0] ? betEvent === null || betEvent === void 0 ? void 0 : betEvent.participants[0] : undefined));
  const awayParticipant = useSelector(state => selectParticipant(state, betEvent !== null && betEvent !== void 0 && betEvent.participants[1] ? betEvent === null || betEvent === void 0 ? void 0 : betEvent.participants[1] : undefined));
  return [homeParticipant, awayParticipant];
};
setGlobal('svs.components.tipsen.hooks', {
  useGetParticipantsByDraw,
  useGetParticipantsByEvent
});

 })(window);